export default "__VITE_ASSET__DY3xGZg9__"